import React from 'react';
import { Wallet, ArrowDownLeft, Clock, CheckCircle2, Download, Filter } from 'lucide-react';
const history = [{
  id: 'PO-9901',
  date: 'Oct 14, 2023',
  amount: 4200,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9900',
  date: 'Oct 01, 2023',
  amount: 3150,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}, {
  id: 'PO-9899',
  date: 'Sep 15, 2023',
  amount: 2800,
  method: 'Bank Transfer •••• 4291',
  status: 'Settled'
}];
export function Payouts() {
  return <div className="space-y-6 max-w-[1600px] mx-auto" data-id="element-623">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-624">
        <div data-id="element-625">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-626">Partner Payouts</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-627">
            Withdraw your earnings and manage settlement frequency.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-628">
          <ArrowDownLeft size={18} data-id="element-629" />
          Request Instant Payout
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-630">
        <div className="bg-slate-900 p-6 rounded-lg text-white" data-id="element-631">
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-632">
            Available for Withdrawal
          </p>
          <h3 className="text-3xl font-bold" data-id="element-633">$12,450.00</h3>
          <div className="mt-4 flex items-center gap-2 text-xs font-bold text-indigo-400" data-id="element-634">
            <Clock size={14} data-id="element-635" />
            <span data-id="element-636">Next auto-payout in 3 days</span>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-637">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-638">
            Total Withdrawn (YTD)
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-639">$84,200.00</h3>
          <p className="mt-4 text-xs font-bold text-emerald-600 flex items-center gap-1" data-id="element-640">
            <CheckCircle2 size={14} data-id="element-641" /> 12 Successful Payouts
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-642">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1" data-id="element-643">
            Pending Clearance
          </p>
          <h3 className="text-3xl font-bold text-slate-900" data-id="element-644">$5,120.00</h3>
          <div className="mt-4 w-full bg-gray-100 h-1.5 rounded-full overflow-hidden" data-id="element-645">
            <div className="h-full bg-indigo-600 w-2/3" data-id="element-646"></div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-647">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between bg-gray-50/50" data-id="element-648">
          <h3 className="font-bold text-slate-900" data-id="element-649">Payout History</h3>
          <div className="flex gap-2" data-id="element-650">
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-651">
              <Filter size={18} data-id="element-652" />
            </button>
            <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-653">
              <Download size={18} data-id="element-654" />
            </button>
          </div>
        </div>
        <table className="w-full text-left border-collapse" data-id="element-655">
          <thead data-id="element-656">
            <tr className="text-[10px] font-bold uppercase tracking-wider text-gray-400 border-b border-gray-100" data-id="element-657">
              <th className="px-6 py-4" data-id="element-658">Payout ID</th>
              <th className="px-6 py-4" data-id="element-659">Date</th>
              <th className="px-6 py-4" data-id="element-660">Amount</th>
              <th className="px-6 py-4" data-id="element-661">Method</th>
              <th className="px-6 py-4" data-id="element-662">Status</th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-663">
            {history.map(h => <tr key={h.id} className="hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0" data-id="element-664">
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-665">{h.id}</td>
                <td className="px-6 py-4 text-gray-500" data-id="element-666">{h.date}</td>
                <td className="px-6 py-4 font-bold text-slate-900" data-id="element-667">
                  ${h.amount.toLocaleString()}.00
                </td>
                <td className="px-6 py-4 text-gray-500 font-medium" data-id="element-668">
                  {h.method}
                </td>
                <td className="px-6 py-4" data-id="element-669">
                  <span className="px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-50 text-emerald-600" data-id="element-670">
                    {h.status}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}